<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table
      :headers="headers"
      :items="file_journey_super_master_list"
      class="elevation-1 mytable"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>File Journey Type</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on"
                >Add File Journey Type</v-btn
              >
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.name"
                          persistent-hint
                          hint="Inward, Outward..."
                          label="Enter File Type"
                          :rules="[(v) => !!v || 'required']"
                        >
                        </v-text-field>
                      </v-col>
                      <!-- <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                     <v-checkbox
                        dense
                        v-model="editedItem.isactive"
                        color="success"
                        label="Active"
                      ></v-checkbox>
                  </v-col>      -->
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="primary darken-1"
                    @click="save"
                    :disabled="!valid"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon  class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon  class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template> -->

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
              >edit</v-icon
            >
          </v-avatar>
        </div>
        <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
      </template>
      <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "File Journey Type",
        align: "center",
        sortable: false,
        value: "name",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    file_journey_super_master_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      //isactive:true
    },
    defaultItem: {
      id: "",
      name: "",
      //isactive:true
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New File Journey Type"
        : "Edit File Journey Type";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    // initializeErrorMsgFalse() {
    //   this.errorMsg.standard = false;
    // },

    onLoad() {
      this.overlay = true;
      axios
        .post("/InwardOutward/adminFileJourneyTypeSuperMaster")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.file_journey_super_master_list =
                res.data.file_journey_super_master_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.file_journey_super_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.category_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.category_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post(
              "/InwardOutward/editFileJourneyTypeSuperMaster",
              this.editedItem
            )
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.file_journey_super_master_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "File Journey Type Updated Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "File Journey Type Already Present!!!"
                ); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post(
            "/InwardOutward/saveFileJourneyTypeSuperMaster",
            this.editedItem
          )
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.file_journey_super_master_list.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "File Journey Type Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "File Journey Type Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>